<template>
  <div id="topbar" :class="alink==1?'':'bgc-wt'">
    <el-row>
      <el-col :span="9">
        <template v-if="alink==1">
          <img class="fl" src="@/assets/images/logo2.png" style="height:60px;">
        </template>
        <template v-else>
          <img class="fl" src="@/assets/images/logo1.png" style="height:60px;">
        </template>
      </el-col>
      <el-col :span="15">
        <el-row :class="alink==1?'menu':'menu2'" type="flex">
          <div class="text-right flexson " :class="alink==1?'onclick':''" @click="alink=1">
            <a href="#part1"><span>首页</span></a>
          </div>
          <div class="text-right flexson" :class="alink==2?'onclick':''" @click="alink=2">
            <a href="#part2"><span>软件业务</span></a>
          </div>
          <div class="text-right flexson" :class="alink==3?'onclick':''" @click="alink=3">
            <a href="#part3"><span>企业简介</span></a>
          </div>
          <div class="text-right flexson" :class="alink==4?'onclick':''" @click="alink=4">
            <a href="#part4"><span>企业优势</span></a>
          </div>
          <div class="text-right flexson" :class="alink==5?'onclick':''" @click="alink=5">
            <a href="#part5"><span>新闻资讯</span></a>
          </div>
          <div class="text-right flexson" :class="alink==6?'onclick':''" @click="dialogVisible = true">
            <span>联系我们</span>
          </div>
          <div class="text-right flexson" :class="alink==7?'onclick':''" @click="openUrl">
            <span>人才招聘</span>
          </div>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog title="" :visible.sync="dialogVisible" class="newdialog" width="790px" append-to-body>
      <div>
        <el-row style="padding-left:40px;padding-bottom:30px;">
          <img class="fl" src="@/assets/images/logo1.png" style="height:40px;">
        </el-row>
        <el-row>
          <el-col :span="17" style="padding-left:40px;">
            <el-row class="hei40">
              <span class="fc-2 ft-size16">地&emsp;&emsp;址:</span>
              <span class="fc-2 ft-size16">北京市昌平区北清路1号院8号楼14层</span>
            </el-row>
            <!-- <el-row class="hei40">
              <span class="fc-2 ft-size16">邮&emsp;&emsp;箱:</span>
              <span class="fc-2 ft-size16 ">155396138@qq.com&emsp;2627504375@qq.com</span>
            </el-row> -->
            <el-row class="hei40">
              <span class="fc-2 ft-size16">电&emsp;&emsp;话:</span>
              <span class="fc-2 ft-size16 ">15869194531(乐)</span>
            </el-row>
            <!-- <el-row class="hei40">
              <span class="fc-2 ft-size16">商务合作:</span>
              <span class="fc-2 ft-size16 pointer">15079173050(乐)</span>
            </el-row> -->
            <el-row class="hei40">
              <span class="fc-2 ft-size16">网&emsp;&emsp;站:</span>
              <span class="fc-2 ft-size16 pointer">http://www.ylybj.cn</span>
            </el-row>
          </el-col>
          <el-col :span="7">
            <div style=" margin-left:40px; border-left:1px solid #ddd; height:200px;" class=" algincenter">
              <div>
                <el-row class="border">
                  <img class="width100 block" src="../assets/icon/qrcode.png" alt="">
                </el-row>
                <el-row class="text-center hei30">
                  <span class="fc-2 ft-size16">微信公众号</span>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: "topbar",
  data() {
    return {
      alink: 1,
      onSub: false, //判断是否在子上
      subTrue: false,
      msgDialog: false, //信息弹窗
      pwdDialog: false, //密码弹窗
      btnloading: false,
      dialogVisible: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    openUrl() {
      this.$router.push({ path: "/joinUs" });
    },
    // 监听滚动
    handleScroll() {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop >= 4400) {
        this.alink = 6;
      } else if (scrollTop >= 3600) {
        this.alink = 5;
      } else if (scrollTop >= 2600) {
        this.alink = 4;
      } else if (scrollTop >= 1600) {
        this.alink = 3;
      } else if (scrollTop >= 340) {
        this.alink = 2;
      } else if (scrollTop <= 242) {
        this.alink = 1;
      }
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/topbar.vue